import { GETOBJECTIVE_SUCCESS, GETOBJECTIVE_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getObjectiveReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETOBJECTIVE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETOBJECTIVE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: [],
            };
        default:
            break;
    }

    return state;
};

export default getObjectiveReducer;



